export const getList = state => {
  return state.list
}
